import { imageSizesAsString } from "../../../utils/imageSizesAsString/imageSizesAsString.util";
import { SbImageLayout } from "./getSbGatsbyImage.util";
import { Sizes } from "../../../interfaces/Sizes";

export const getSbGatsbyImageOutputSizes = (outputWidth: number, layout: SbImageLayout, sizes?: Sizes, width?: number): string => {
    if (sizes) return imageSizesAsString(sizes);
    switch (layout) {
        case 'fullWidth': return `100%`;
        case 'constrained': return `(min-width: ${width || outputWidth}px) ${outputWidth || width}px, 100%`;
        case 'fixed': return `${outputWidth}px`;
    }
}